/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */

import { Directive, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appInfinteScroll]'
})
export class InfinteScrollDirective {
  @Output() scrolledStart = new EventEmitter<any>();
  @Output() scrolledEnd = new EventEmitter<any>();
  @Output() scrolledCur = new EventEmitter<any>();

  @HostListener('window:scroll', ['$event'])
  onScroll(event) {
    let tracker = event.target.scrollingElement;
    let top;
    if (!tracker) {
      tracker = document.body;
      top = (document.documentElement && document.documentElement.scrollTop) ||
        document.body.scrollTop;
    } else {
      top = tracker.scrollTop;
    }
    const limit = tracker.scrollHeight - tracker.clientHeight - 1;
    const windowHeight = 'innerHeight' in window ? window.innerHeight : document.documentElement.offsetHeight;
    const windowBottom = windowHeight + window.pageYOffset - tracker.clientHeight;

    this.scrolledCur.emit({
      curPos: top,
      limit: limit,
      clientHeight: tracker.clientHeight,
      scrollPercent: ((top / limit) * 100)
    });

    if (windowBottom >= limit) {
      // tracker.scrollTop = tracker.scrollTop - 1;
      this.scrolledEnd.emit({
        curPos: top,
        limit: limit,
        scrollPercent: ((top / limit) * 100),
        end: true
      });

    }
    if (top <= 0) {
      tracker.scrollTop = 1;
      this.scrolledStart.emit({
        curPos: top,
        limit: limit,
        scrollPercent: ((top / limit) * 100),
        start: true
      });
    }

  }

  constructor() { }

}
